import { Spinner } from 'react-bootstrap';

const Loading = () => (
  <div
    className="top-50 start-50 translate-middle bg-transparent"
    style={{ position: 'fixed' }}
  >
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

export default Loading;
